import { PAYMENT_TYPE } from './../../payment/services/constants';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { findIndex, set } from 'lodash';
import moment from 'moment';
import actions from './actions';
import { NAME_REDUCER } from './constants';
import { IEditStaffPayload, IResponseCreditCardTicket, IResponseTicket } from './types/api';
import { IState } from './types/reducer';
import shopActions from 'services/shop/actions';

const initialState: IState = {
  ticketList: [],
  total: 0,
  params: {
    status: 'OPEN_TICKET',
    date: moment().format('MM-DD-YYYY'),
    page: 1,
    size: 10,
  },
  ticketDetailsById: null,
  adjustTipList: [],
  visibleCusPhone: false,
  printVoidTicketData: null,
  printRefundTicketData: null,
  summaryCreditCards: null,
  summaryTickets: null,
  isVerifyKeyIn: false,
  staffsList: [],
  creditCardParams: {
    statuses: ['CLOSED','VOID','REFUND'],
    startDate:moment().format('MM-DD-YYYY'),
    endDate: moment().format('MM-DD-YYYY'),
    page: 1,
    size: 10
  },
  creditCardTicketList: [],
  totalCreditCardTicket: 0,

};

export const Slice = createSlice({
  name: NAME_REDUCER,
  initialState,
  reducers: {
    setIsVerifyKeyIn: (state, { payload }: { payload: boolean }) => {
      state.isVerifyKeyIn = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(shopActions.get.staffs.success, (state, { payload }) => {
        state.staffsList = payload;
      })
      .addCase(actions.getSummaryTickets.success, (state, { payload }) => {
        state.summaryTickets = payload;
      })
      .addCase(actions.getSummaryCreditCards.success, (state, { payload }) => {
        state.summaryCreditCards = payload;
      })
      .addCase(actions.setVisibleCusPhone, (state, { payload }) => {
        state.visibleCusPhone = payload;
      })
      .addCase(actions.getTickets.success, (state, { payload }: PayloadAction<IResponseTicket>) => {
        state.ticketList = payload.content;
        state.total = payload.totalElements;
      })
      .addCase(actions.setTicketsParams, (state, { payload }) => {
        const _params = {
          ...(state.params ?? {}),
          ...payload,
        };
        if (_params.staffId === '' || _params.staffId === undefined || _params.staffId === null) {
          delete _params.staffId;
        }
        if (
          _params.customerId === '' ||
          _params.customerId === undefined ||
          _params.customerId === null
        ) {
          delete _params.customerId;
        }
        if (_params.ticketNumber === '') {
          delete _params.ticketNumber;
        }
        if (_params.last4Num === '') {
          delete _params.last4Num;
        }
        if (_params.paymentType === undefined) {
          delete _params.paymentType;
        }
        state.ticketList = [];
        state.params = _params;
      })
      .addCase(actions.addTip, (state, { payload }) => {
        if (state.ticketDetailsById) {
          set(state.ticketDetailsById, 'tip', payload);
        }
      })
      .addCase(
        actions.editStaff.success,
        (state, { payload }: PayloadAction<IEditStaffPayload>) => {
          if (state.ticketDetailsById) {
            const index = findIndex(state.ticketDetailsById.items, {
              staffId: payload.existStaffId,
            });
            const staffNewData = state.staffsList.find((o) => o.id === payload.newStaff.id);
            set(
              state.ticketDetailsById,
              `items[${index}].staffName`,
              payload.newStaff.firstName + ' ' + payload.newStaff.lastName
            );
            set(state.ticketDetailsById, `items[${index}].staffId`, payload.newStaff.id);
            set(state.ticketDetailsById, `items[${index}].avatar`, staffNewData?.urlImage || '');
          }
        }
      )

      .addCase(actions.getTicketDetails.success, (state, { payload }) => {
        state.ticketDetailsById = payload;
      })
      .addCase(actions.doPrintVoidTicket.success, (state, { payload }) => {
        state.printVoidTicketData = payload;
      })
      .addCase(actions.doPrintVoidTicket.fetch, (state) => {
        state.printVoidTicketData = null;
      })
      .addCase(actions.doPrintRefundTicket.success, (state, { payload }) => {
        state.printRefundTicketData = payload;
      })
      .addCase(actions.doPrintRefundTicket.fetch, (state) => {
        state.printRefundTicketData = null;
      })
      .addCase(actions.refundTicketByBillId.success, () => {
        // state.ticketDetailsById = payload;
        // do sth with ticketDetailsById
      })
      .addCase(actions.voidTicketByBillId.success, () => {
        // do sth with ticketDetailsById
      })
      .addCase(actions.adjustTip.success, (state, { payload }) => {
        state.adjustTipList = payload;
      })
      .addCase(actions.handleChangeAdjustTip, (state, { payload }) => {
        const index = state.adjustTipList.findIndex((item) => item?.billId === payload.billId);
        if (index !== -1) {
          if (payload?.tip !== 0) {
            state.adjustTipList[index].tip = payload.tip ?? 0;
          } else {
            state.adjustTipList.splice(index, 1);
          }
        } else {
          state.adjustTipList.push(payload);
        }
      })
      .addCase(
        actions.editCashByBillId.success,
        (state, { payload }: PayloadAction<{ amount: number; billId: string }>) => {
          if (state.ticketDetailsById) {
            state.ticketDetailsById.payments = state.ticketDetailsById.payments.map((item) => {
              if (item.paymentType === PAYMENT_TYPE.CASH) {
                return { ...item, amount: payload.amount };
              }
              return item;
            });
          }
        }
      )
      .addCase(actions.doInit, (state) => {
        state.params = {
          status: 'OPEN_TICKET',
          date: moment().format('MM-DD-YYYY'),
          page: 1,
          size: 10,
        };
        state.ticketList = [];
        state.total = 0;
        state.isVerifyKeyIn = false;
        state.ticketDetailsById = null;
        state.adjustTipList = [];
        state.visibleCusPhone = false;
        state.creditCardParams =  {
          statuses: ['CLOSED','VOID','REFUND'],
          startDate:moment().format('MM-DD-YYYY'),
          endDate: moment().format('MM-DD-YYYY'),
          page: 1,
          size: 10
        };
        state.creditCardTicketList = [];
        state.totalCreditCardTicket = 0;
      });
      //CreditCard
      builder
      .addCase(actions.setCreditCardParams, (state, { payload }) => {
        const _params = {
          ...(state.creditCardParams ?? {}),
          ...payload,
        };
        state.creditCardTicketList = [];
        state.creditCardParams = _params;
      })
      .addCase(
        actions.getReportCreditCards.success,
        (state, { payload }: PayloadAction< IResponseCreditCardTicket>) => {
          state.creditCardTicketList = payload.content;
          state.totalCreditCardTicket = payload.totalElements;
        }
      );
  },
});
export const ticketListUIActions = Slice.actions;
const ticketListServiceReducer = Slice.reducer;
export default ticketListServiceReducer;
